import { cloneDeep } from 'lodash'
import moment, { DurationInputArg1, DurationInputArg2 } from "moment";

type MomentOptions = { format?: string, amount?: DurationInputArg1, unit?: DurationInputArg2 }

export type FromToTicksReturnType = ReturnType<typeof fromToTicks>

export function fromToTicks(fromDate: string, toDate: string, options?: MomentOptions) {
  const timeTicks: Array<string> = []
  const dataTicks: Array<number> = []

  const from = moment(fromDate)
  const to = moment(toDate)

  const format = options?.format ?? "YYYY-MM-DD"
  const addAmount = options?.amount ?? 1
  const addUnit = options?.unit ?? 'day'

  while (!from.isAfter(to)) {
    timeTicks.push(from.format(format))
    dataTicks.push(0)
    from.add(addAmount, addUnit)
  }

  const mapTimeData = timeTicks.reduce((map:Record<string, number>, current) => {
    map[current] = 0

    return map
  }, {})

  return cloneDeep({ timeTicks, dataTicks, mapTimeData })
}
